import { Component, effect, ViewChild, inject } from '@angular/core';
import { ServiceSettingsMedicationStore } from './service-settings-medication.store';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import {
    SERVICE_SETTINGS_MEDICATION_TYPE_KEY,
    ServiceSettingsMedicationWindowTypeEnum,
} from '@libs/types/src/services/types/service-settings-medication.type';
import { ActivatedRoute, Router } from '@angular/router';
import { contentGlobalSuccess } from '../../../../content.error';
import { Divider } from '@openng/optimus-ui/divider';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-medication',
    templateUrl: './service-settings-medication.component.html',
    providers: [ServiceSettingsMedicationStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        CheckInputComponent,
        SelectInputComponent,
        TranslatePipe,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsMedicationComponent {
    protected readonly store = inject(ServiceSettingsMedicationStore);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);


    @ViewChild(ServiceSettingsCommonComponent) serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({
        showColumnTimesAdministrated: fb.control<boolean>(true),
        showConnectWithProcedureOption: fb.control<boolean>(true),
        windowType: fb.control<string>(ServiceSettingsMedicationWindowTypeEnum.SIMPLE),
    });

    windowTypeOptions = [
        { name: 'simple' },
        { name: 'extended' },
    ];

    constructor() {
        effect(() => {
            const defaultValues = this.store.medicationSettings();
            if (defaultValues) {
                this.form.patchValue({
                    showColumnTimesAdministrated: defaultValues?.showColumnTimesAdministrated ?? true,
                    showConnectWithProcedureOption: defaultValues?.showConnectWithProcedureOption ?? true,
                    windowType: defaultValues?.windowType || ServiceSettingsMedicationWindowTypeEnum.SIMPLE,
                });
            }
        });
    }

    save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            ...JSON.parse(this.serviceSettingsCommonComponent.getFormData()),
            showColumnTimesAdministrated: Boolean(this.form.value.showColumnTimesAdministrated),
            showConnectWithProcedureOption: Boolean(this.form.value.showConnectWithProcedureOption),
            windowType: this.form.value.windowType || ServiceSettingsMedicationWindowTypeEnum.SIMPLE,
        };

        this.store.api.updateServiceSettings({
            key: SERVICE_SETTINGS_MEDICATION_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: Number(serviceId),
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

    async cancel() {
        this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }
}
